import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
} from '@mui/material';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { useNavigate } from 'react-router-dom';

const BRAND = '#6318C6';
const BRAND_LIGHT = '#f3eeff';

export default function WhatsAppRequiredModal({ open }) {
  const navigate = useNavigate();

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(99,24,198,0.18)',
        },
      }}
    >
      {/* Purple gradient header */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${BRAND} 0%, #9333ea 100%)`,
          pt: 4,
          pb: 3,
          px: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        {/* Icon bubble */}
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            bgcolor: 'rgba(255,255,255,0.18)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            border: '2px solid rgba(255,255,255,0.3)',
          }}
        >
          <PhoneAndroidIcon sx={{ fontSize: 32, color: '#fff' }} />
        </Box>

        <Typography variant="h6" fontWeight={700} color="#fff" textAlign="center">
          WhatsApp Number Required
        </Typography>
        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', mt: 0.5, textAlign: 'center' }}>
          Complete your profile to continue
        </Typography>
      </Box>

      <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="center"
          sx={{ lineHeight: 1.6 }}
        >
          Please add your WhatsApp number and country code to your profile to continue using the application.
        </Typography>

        {/* Info nudge */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            bgcolor: '#fafafa',
            border: '1px solid #e5e7eb',
            borderRadius: '10px',
            p: 1.5,
            mt: 2,
          }}
        >
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: '8px',
              bgcolor: BRAND_LIGHT,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <PhoneAndroidIcon sx={{ fontSize: 18, color: BRAND }} />
          </Box>
          <Typography variant="caption" color="text.secondary" lineHeight={1.5}>
            Your WhatsApp number is used for notifications and account verification.
          </Typography>
        </Box>
      </DialogContent>

      {/* Actions */}
      <Box sx={{ px: 3, pb: 3, pt: 1.5 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={() => navigate('/profile')}
          sx={{
            background: `linear-gradient(135deg, ${BRAND} 0%, #9333ea 100%)`,
            borderRadius: '10px',
            textTransform: 'none',
            fontWeight: 700,
            py: 1.2,
            boxShadow: '0 4px 14px rgba(99,24,198,0.35)',
            '&:hover': {
              background: `linear-gradient(135deg, #5010b0 0%, #7e22ce 100%)`,
              boxShadow: '0 6px 20px rgba(99,24,198,0.45)',
            },
          }}
        >
          Complete Profile
        </Button>
      </Box>
    </Dialog>
  );
}
